// Centralized verbatim copy for the Share Trivvy modals.
// Keep all sharing-related user-facing strings here so they are defined once
// and reused across the share components (no inline duplication).

export const SHARE_RESHARE_TRIVVY = "Share/Reshare Trivvy";

// ---- Top info banner (Email a Link / Text a Link / Text only) ----
// Line 1 wraps an inline "Users List" chip, so the surrounding copy is split
// into a leading and trailing segment around that chip.
export const SHARE_BANNER_LINE1_LEAD =
  "To share a Trivvy with users on this platform, first open the";
export const SHARE_BANNER_LINE1_TAIL =
  "in the top right and upload a file or invite them. Then return here to share.";
export const SHARE_BANNER_LINE2 =
  "Otherwise, go back to the previous screen to share another way.";
export const SHARE_USERS_LIST_CHIP = "Users List";

// ---- In-card permissions Note footer ----
export const SHARE_NOTE_LABEL = "Note:";
export const SHARE_NOTE_PUBLIC_LINK =
  "This means anyone with the link can receive the Trivvy.";

// ---- "Select users" section heading + subtitles ----
export const SHARE_SELECT_USERS_HEADING = "Select users to share this Trivvy";
export const SHARE_SECTION_SUBTITLE_SMS =
  "Choose a recipient group, then send or reshare below.";
export const SHARE_SECTION_SUBTITLE_FILTER =
  "Pick all users or narrow the list using filters below.";

// ---- Select-all pill ----
export const SHARE_SELECT_ALL_USERS = "Select all users";
export const SHARE_DESELECT_ALL_USERS = "Deselect to remove all users";

// ---- Segmented tab labels ----
export const SHARE_TAB_NEW_USERS = "New Users";
export const SHARE_TAB_ALREADY_SAVED = "Already saved";

// ---- Export CSV pill ----
export const SHARE_EXPORT_CSV = "Export CSV";

// ---- Pagination prev/next controls ----
export const SHARE_PAGINATION_PREVIOUS = "Previous";
export const SHARE_PAGINATION_NEXT = "Next";

// ---- Share Outcomes modal delivery note ----
export const SHARE_OUTCOMES_DELIVERY_NOTE =
  "Outcomes will be shared using the same delivery method as the survey.";

// ---- Shareable short link (TBV-938) — Share modal + list Copy Link ----
export const SHARE_LINK_LABEL = "Shareable Link";
export const SHARE_LINK_LOADING = "Generating link...";
export const SHARE_LINK_RETRY = "Retry";
export const SHARE_LINK_COPY = "Copy";
export const SHARE_LINK_COPIED_LABEL = "Copied";
export const SHARE_LINK_COPIED = "Link copied!";
export const SHARE_LINK_COPY_FAILED =
  "Couldn't copy the link. It's selected — copy it manually.";
export const SHARE_LINK_LOAD_FAILED =
  "We couldn't create the short link. Please try again.";
export const SHARE_LINK_USE_ORIGINAL = "Use original link";
export const SHARE_LINK_FALLBACK_NOTE =
  "The short link isn't available right now. This is the original (longer) link.";
export const SHARE_LINK_SESSION_EXPIRED =
  "Your session has expired. Please sign in again.";
export const SHARE_LINK_PERMISSION_DENIED =
  "You don't have permission to share this item.";
export const SHARE_LINK_UNAVAILABLE =
  "This item is no longer available to share.";
export const SHARE_LINK_RATE_LIMITED =
  "Too many link requests. Please wait a moment and try again.";
export const SHARE_LINK_CONFIG_ERROR =
  "This link can't be copied because of a configuration problem. Please contact support.";
export const SHARE_LINK_FOLDER = "Folders cannot be shared.";
export const SHARE_LINK_DIALOG_TITLE = "Copy Link";
export const SHARE_QR_LOADING = "Generating QR code...";
export const SHARE_QR_DOWNLOADED = "QR code downloaded.";
export const SHARE_QR_DOWNLOAD_FAILED = "Couldn't download the QR code. Please try again.";
